import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../common/services/base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { Role } from '../../common/interfaces/role.interface';

@Injectable()
export class CommonRoleService extends BaseService {

    constructor(private http: HttpClient) {
        super();
    }

    findAllRolesForCurrentCorporateClient(): Observable<Role[]> {
        return this.http.get(this.getApiUrl() + '/roles')
            .pipe(map((res: any) => res?.roles || []));
    }
}
